import type { ContactCreateSchema } from '@liscio/api';

import type { CreateContactFormValues } from './createContactValidationSchema';

export type CreateContactPayload = ContactCreateSchema & {
  send_invitation?: boolean;
};

const isPresent = (value: unknown): value is string =>
  value !== undefined && value !== null && value !== '';

/**
 * Builds the flat JSON body for `POST /api/v5/firms/contacts` from react-hook-form state.
 * Omits empty optional fields; maps `phone` → `phone_number`.
 */
export function mapCreateContactFormValuesToApiPayload(
  values: CreateContactFormValues,
  accountId?: string | null
): CreateContactPayload {
  const payload: CreateContactPayload = {
    first_name: values.first_name,
    last_name: values.last_name,
  };

  if (isPresent(values.primary_email)) {
    payload.primary_email = values.primary_email;
  }

  if (isPresent(values.job_title)) {
    payload.job_title = values.job_title;
  }

  if (isPresent(values.phone)) {
    payload.phone_number = values.phone;
  }

  if (isPresent(accountId)) {
    payload.account_id = accountId;
  }

  if (values.send_invitation) {
    payload.send_invitation = true;
  }

  return payload;
}
